import { NgModule } from '@angular/core';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginRouteGuard, NotLoginRouteGuard } from './route-guard';
import { MysqlService } from './services/mysql.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthorizationService } from './services/authorization.service';
import { VersionInfoModule } from './components/version-info/version-info.module';

import { PreviewService } from './services/preview.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { IonicStorageModule } from '@ionic/storage';
import { getEnv } from './shared';
import { PartPickerModalComponent } from './components/part-picker-modal/part-picker-modal.component';

import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';

//import { Firebase } from '@ionic-native/firebase/ngx';
//import { AngularFireAuthModule } from '@angular/fire/auth/';
//import { AngularFirestore, AngularFirestoreModule } from '@angular/fire/firestore';
//import {  AngularFireFunctionsModule} from '@angular/fire/functions';

import { IonicGestureConfig } from './ionic-gesture-config'
import * as CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { BaseRouteReuseStrategy } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { UserService } from './services/user.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { VersionInfoComponent } from './components/version-info/version-info.component';

export const firebaseConfig = {
  apiKey: "AIzaSyBesDqcByu-aW2sEyKJ_iPFSkx9k7a2RW4",
  authDomain: "xpert-gg-4aaa1.firebaseapp.com",
  databaseURL: "https://xpert-gg-4aaa1.firebaseio.com",
  projectId: "xpert-gg-4aaa1",
  storageBucket: "xpert-gg-4aaa1.appspot.com",
  messagingSenderId: "148779623923",
  appId: "1:148779623923:web:73fae748294ca81a4d1e86"
};


@NgModule({
  declarations: [AppComponent, PartPickerModalComponent
    //SpinnerComponent
  ],
  imports: [
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot({
      driverOrder: [CordovaSQLiteDriver._driver, 'indexeddb', 'websql']
    }),
    AppRoutingModule,
    HttpClientModule,

    ServiceWorkerModule.register('firebase-messaging-sw.js', { // <--- Cambia da ngsw-worker.js a questo
      enabled: environment.production,
      registrationStrategy: 'registerImmediately'
    }),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFirestoreModule.enablePersistence(),
    AngularFireAuthModule,
    AngularFireFunctionsModule,
    VersionInfoModule
  ],
  providers: [
    { provide: BaseRouteReuseStrategy, useClass: IonicRouteStrategy },
    LoginRouteGuard, NotLoginRouteGuard, MysqlService,
    AuthorizationService,
    PreviewService,
    UserService,
    { provide: HAMMER_GESTURE_CONFIG, useClass: IonicGestureConfig },
  ],
  bootstrap: [AppComponent],

  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})


export class AppModule {
}

